import { useState } from "react";
import { useSelector } from "react-redux";
import FMSForm from "./FMSForm";
import { Card, Button, Modal, CloseButton, Spinner } from 'react-bootstrap';
import DataGrid from '../../controls/DataGrid.js/DataGrid'

import Icon from "../../controls/Icons/Icon";
import useFetchWithCancellation from "../../../customhooks/useFetchWithCancellation";
import { ErrorBoundary } from 'react-error-boundary';
import ErrorHandler from "../../controls/ErrorHandler";
const FMS = () => {
    const { fetchData } = useFetchWithCancellation();
    const state = useSelector(state => state);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState({
    });
    const columns = [
        {
            field: "FMSName",
            title: "FMS Name",
            sortable: true,
        },
        {
            field: "Address",
            title: "Address",
            sortable: true,
        },
        {
            field: "Zipcode",
            title: "Zipcode",
            sortable: true,
        },
        {
            field: "state.StateName",
            title: "State",
            sortable: true,
        },
        {
            dataField: "remove",
            title: "",
            text: "Delete",
            formatter: (cellContent, row) => {
                return (<div>
                    {state.access.edit ? <Button
                        className="btn-xs me-2 mb-2 p-0" variant="link"
                        onClick={() => handleEdit(row)}
                    ><Icon name="BsPencilFill" className='fs-5' /></Button> : ""}

                    {state.access.delete ? <Button variant="link"
                        className="btn-xs mb-2 p-0"
                        onClick={() => handleDelete(row)}
                    >
                        <Icon name="BsTrash" className='fs-5' />
                    </Button> : ""}
                </div>
                );
            },
        }
    ];

    const handleEdit = (res) => {
        setInputValue(res)
        setShowModal(true)
    };

    const handleDelete = ((res) => {
        window.confirm("Do you want to delete the FMS?", function () {
            setLoading(true);
            fetchData(state.projectdetail.API + "/fms/delete?Id=" + res.Id, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                    window.alert("Deleted successfuly");
                    setRefreshGrid(!refreshGrid);
                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("FMS.js ==> delete", null, null, err);
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
                setLoading(false);
            });
        })

    });

    const options = {
        dataType: "server",
        showExport: true,
        showRefresh: true,
        sortName: "FMSName",
        sortOrder: "asc",
    };
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleAdd = () => {
        setInputValue([{}])
        setShowModal(true)
    };
    const handleAfter = (res) => {
        if (res.Succeeded) {
            window.alert("FMS saved successfully");
            handleClose();
            setRefreshGrid(!refreshGrid);
        }
        else {
            window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
        }
    };
    return (
        <ErrorBoundary FallbackComponent={ErrorHandler}>      
            <h4 className='form-heading mb-4'>
                FMS
                <div className='d-inline-block float-end'>
                    {state.access.add && <Button onClick={handleAdd}>Add New FMS</Button>}&nbsp;
                </div>
            </h4>
            <Card>
                <Card.Body>
                    {loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}
                    <DataGrid url={state.projectdetail.API + "/fms/grid"} classes="table table-striped" options={options} columns={columns} refresh={refreshGrid} />
                </Card.Body>
            </Card>
            <Modal show={showModal} onHide={handleClose} size="lg" backdrop="static">
                <Modal.Header>
                    <h4>{inputValue.Id ? "Edit " : "Add "} FMS</h4>
                    <CloseButton onClick={handleClose} className="btn-close" />
                </Modal.Header>
                <Modal.Body>
                    <FMSForm afterSave={handleAfter} _inputValue={inputValue} showPassword={true} onCancel={handleClose} />
                </Modal.Body>
            </Modal>
        </ErrorBoundary>
    ); 
}
export default (FMS);
